var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnionQuickAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.8 11c0 5.412-4.388 9.8-9.8 9.8S1.2 16.412 1.2 11 5.588 1.2 11 1.2s9.8 4.388 9.8 9.8m1.2 0c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11M11 4.74a.6.6 0 0 1 .6.6v5.06h5.06a.6.6 0 0 1 0 1.2H11.6v5.06a.6.6 0 1 1-1.2 0V11.6H5.34a.6.6 0 1 1 0-1.2h5.06V5.34a.6.6 0 0 1 .6-.6",
  clipRule: "evenodd"
})));
export { SvgUnionQuickAdd as ReactComponent };